import React from "react";
import { TextField } from "@mui/material";
import { RangeField } from "modules/MainSurveyEditor/helpers/blockForm";

export const SurveyRangeField = (props: SurveyRangeFieldProps) => {
  const { value = {min: 0, max: 100}, onChange } = props;

  return (
    <div className="layout-survey-range-field">
      <TextField
        label="Min"
        type="number"
        value={value.min}
        placeholder="0"
        onChange={(e) => onChange({ ...value, min: parseFloat(e.target.value) })}
      />
      <TextField
        label="Max"
        type="number"
        value={value.max}
        placeholder="100"
        onChange={(e) => onChange({ ...value, max: parseFloat(e.target.value) })}
      />
    </div>
  );
};

interface SurveyRangeFieldProps {
  value?: RangeField;
  onChange: (value: RangeField) => void;
}
